// A utility to alphabetize names by last name (to be passed into an array sort method).
// Not foolproof, obviously (e.g. there may be edge cases where this fails),
// but this is a "good enough" solution for most purposes.
export default function compareByLastName(nameA, nameB) {
  // Don't attempt to compare if undefined
  if (!nameA || !nameB) return 0

  // Split the names into parts based on spaces
  const partsA = nameA.trim().split(" ")
  const partsB = nameB.trim().split(" ")

  // Get the last part of the names
  const lastNameA = partsA[partsA.length - 1]
  const lastNameB = partsB[partsB.length - 1]

  // Use localeCompare to compare the last names
  return lastNameA.localeCompare(lastNameB)
}
